export default __webpack_public_path__ + "static/wlc-logo-cfd7afa0.png";